import product1 from '../../../assets/images/focus.png';
import product2 from '../../../assets/images/forum.webp';
import product3 from '../../../assets/images/todo.jpg';
import product4 from '../../../assets/images/class.jpg';
import product5 from '../../../assets/images/doubt.jpg';
import product6 from '../../../assets/images/tutor2.jpg';

export const productData = [
  {
    img: product6,
    alt: 'tutor',
    name: '1:1 Mentorship',
    desc:
      "Mentors can be searched according to students' goals. Less wastage of time surfing through the infinite resources available in the internet or running behind previous year toppers. 'Cause mentors can create courses or classes based on their experiences.",
  },


  {
    img: product2,
    alt: 'Forum',
    name: 'Discussion Forum',
    desc:
      'No education is complete without the students engaging with the topic. An interactive discussion forum caters to the unrest curiosity of the young minds to actively discuss among themselves and clarify with the mentors.',
  },
  {
    img: product5,
    alt: 'Doubt Solving',
    name: 'Live Classes and Doubt Solving Sessions',
    desc:
      'Mentors and tutors can schedule classes or doubt solving sessions over any electronic means like GMeet or Zoom. ',
  },
  {
    img: product1,
    alt: 'Study Rooms',
    name: 'Study Rooms',
    desc:
      'Did you miss the tranquil of libraries in the online studying? No worries. We have exact solution through our carefully designed Study Rooms. No advertisements, no distractions, 100% Focus.',
  },
  {
    img: product4,
    alt: 'Chat',
    name: 'Interaction',
    desc:
      'An active interaction with the mentors ensures the right transit of knowledge. Students can contact with their mentors to solve their doubts, ask for guidance or simply resolve their career issues through our in-built chat feature.',
  },

  {
    img: product3,
    alt: 'todo',
    name: 'Effective Checklist',
    desc:
      'Tracking progress is vital. Our platform provides the means to have a reality check everytime one completes a planned task. ',
  }
];
